
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/-/where-to-buy",
      function () {
        return require("private-next-pages/-/where-to-buy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/-/where-to-buy"])
      });
    }
  